import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/index.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Parcels from "@/pages/Parcels";
import ParcelDetail from "@/pages/ParcelDetail";
import Jewelry from "@/pages/Jewelry";
import JewelryDetail from "@/pages/JewelryDetail";
import Expenses from "@/pages/Expenses";
import Sales from "@/pages/Sales";
import Ledger from "@/pages/Ledger";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import { Toaster } from "sonner";

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/parcels" element={<Parcels />} />
                <Route path="/parcels/:id" element={<ParcelDetail />} />
                <Route path="/jewelry" element={<Jewelry />} />
                <Route path="/jewelry/:id" element={<JewelryDetail />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/sales" element={<Sales />} />
                <Route path="/ledger" element={<Ledger />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/settings" element={<Settings />} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRouter />
                <Toaster theme="light" position="top-right" richColors closeButton />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
